import { render } from "./TournamentAgeCategoryEditPage.vue?vue&type=template&id=7b7b6e1e"
import script from "./TournamentAgeCategoryEditPage.vue?vue&type=script&lang=js"
export * from "./TournamentAgeCategoryEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__